/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function handlePanelClick(event){
//   console.log('click');
//   console.log(this);
//   document.querySelectorAll(".show_more")[0].classList.add("hide");
//   document.querySelectorAll(".bottomImg")[0].classList.remove("small__height");
//   document.querySelectorAll(".bottomImg")[0].classList.add("animation");
// }
// var allPanelElems = document.querySelectorAll(".show_more");
// for (var i = 0, len = allPanelElems.length; i < len; i++){
//   allPanelElems[i].addEventListener("click", handlePanelClick);
// }





jQuery(function($){
  
  $( ".bottomImg" ).each(function( index ) {

    var divheight = $(this).height();
    if(divheight > 150){
      $(this).css('max-height',$(this).height());
      $(this).children('.des_bottom_div').removeClass('hide');
    }else{
      $(this).removeClass('small__height');
      
    }
  });

  $(document).on('click', '.show_more',function(){
    $(this).addClass('hide');
    $(this).siblings('.show_less').removeClass('hide');
    $(this).parents('.bottomImg').removeClass('small__height');
    $(this).parents('.bottomImg').removeAttr('style');
  });
  
  $(document).on('click', '.show_less',function(){
     $(this).addClass('hide');
    $(this).siblings('.show_more').removeClass('hide');
    $(this).parents('.bottomImg').addClass('small__height');
    $(this).parents('.bottomImg').css('height',$(this).parents('.bottomImg').height());
  });
  
});